import ResponsiveImage from '../common/ResponsiveImage'
import LinksList from '../common/LinksList'

interface LockUpHeroProps {
	block: any
	fallBackTitle?: string
}

const LockUpHero = (props: LockUpHeroProps) => {

	const { block, fallBackTitle } = props

	if (!block) {
		return null
	}

	const title: string | null = block.heading ? block.heading : fallBackTitle ? fallBackTitle : null
	const image: any = block.image && block.image.length > 0 ? block.image[0] : null

	return (
		<div className={`lock-up-hero lock-up-hero--align-image-right lock-up-hero--color-gray`}>

			<div className={`lock-up-hero__media`}>
				<div className="lock-up-hero__media-wrapper">
					<ResponsiveImage
						image={block.image && block.image.length > 0 ? block.image[0] : null}
						cleanImplementation={true}
						containerClass={`lock-up-hero__media-container`}
					/>
				</div>
			</div>

			<div className="lock-up-hero__content">
				<div className="lock-up-hero__content-wrapper">
					<div className="lock-up-hero__content-container">
						{title && <h1>{title}</h1>}
						{block.text && <div dangerouslySetInnerHTML={{ __html: block.text }} />}
						<LinksList links={block.links} />
					</div>
				</div>
			</div>

		</div>
	)

}
export default LockUpHero
